// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'arrow-above-row-right';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinejoin='round'>
    <path
      strokeLinecap='round'
      d='M7.344 11.232h10.08v5.616H7.344zM10.8 4.68H.576m7.992 2.304L10.8 4.68 8.568 2.448'
    />
    <path d='M12.384 16.992v-5.76' />
    <path fill='currentColor' strokeLinecap='round' d='M.576 11.232h4.68v5.616H.576z' />
  </g>
);

export const viewBox = '0 0 18 18';
